import PropTypes from 'prop-types';
import React from 'react';
import View from '@loggi/ui/components/view';

class CheckboxGroup extends React.Component {
  getChildContext() {
    const { name, selectedValue, onChange } = this.props;
    return { name, selectedValue, onChange };
  }

  render() {
    const { children, className } = this.props;
    const listComponents = React.Children.map(children, child =>
      React.cloneElement(child)
    );

    return (
      <View inline={!__NATIVE__} className={className}>
        {listComponents}
      </View>
    );
  }
}

CheckboxGroup.displayName = 'CheckboxGroup';

CheckboxGroup.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  selectedValue: PropTypes.array.isRequired,
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element
  ]).isRequired
};

CheckboxGroup.childContextTypes = {
  name: PropTypes.string,
  selectedValue: PropTypes.array,
  onChange: PropTypes.func
};

CheckboxGroup.defaultProps = {
  selectedValue: []
};

export default CheckboxGroup;
